module.exports = __webpack_public_path__ + "img/1.45359cc2.png";